import { Flex, Typography } from '@banhala/ui-kit';

interface FolderListHeaderProps {
  totalCount: number;
  onPressEditOrder: () => void;
}

export const FolderListHeader = ({
  totalCount,
  onPressEditOrder,
}: FolderListHeaderProps) => {
  return (
    <Flex.Row
      alignItems={'center'}
      justifyContent={'space-between'}
      padding={{ vertical: 8, right: 4 }}
    >
      <Flex testID={`서랍개수?value=${totalCount}`}>
        <Typography type={'body2'} color={'content_tertiary'}>
          서랍 {totalCount}개
        </Typography>
      </Flex>
      {totalCount > 1 && (
        <Flex
          hitSlop={{ top: 8, bottom: 8, left: 4, right: 4 }}
          onPress={onPressEditOrder}
          testID={`서랍순서편집버튼`}
        >
          <Typography type={'body3'} color={'content_secondary'}>
            순서 편집
          </Typography>
        </Flex>
      )}
    </Flex.Row>
  );
};
